import script from "./MatchProducts.vue?vue&type=script&setup=true&lang=ts"
export * from "./MatchProducts.vue?vue&type=script&setup=true&lang=ts"

import "./MatchProducts.vue?vue&type=style&index=0&id=763d836a&scope=true&lang=css"

const __exports__ = script;

export default __exports__